module.exports = __webpack_public_path__ + "static/media/marketoPlug2x.7d099eda.png";